<template>
  <div id="PageNotFound" class="wrapper-text">
    <div class="d-block text-center">
      <img src="../assets/404.jpg" class="img-fluid mb-3" alt="404" />
      <h1>صفحه مورد نظر یافت نشد</h1>
    </div>
  </div>
</template>
